function initNavigation() {
    const oMenuToggles = document.querySelectorAll('.js-toggle-menu');
    const oMobileMenu = document.querySelector('.js-mobile-navigation');
    let oMobileMenuSubItems = null;
    let oMobileMenuSubBackLink = null;
    if (oMobileMenu) {
        oMobileMenuSubItems = oMobileMenu.querySelectorAll('.sidebar-navigation__list__item, .mobile-navigation__sub__item');
        oMobileMenuSubBackLink = oMobileMenu.querySelector('.js-mobile-nav-back');
    }

    const oMainNavigation = document.querySelector('.navigation');
    const oMainMenuItems = document.querySelectorAll('.navigation .navigation__list__item');

    const oSideNavigation = document.querySelector('.js-side-navigation');
    let oSideNavigationBackdrop;

    let bMobileMenuActive = false;
    let bSideNavigationActive = false;

    let fHoverInTimeout;
    let fHoverOutTimeout;

    const toggleBtnClasses = () => {
        for (let i = 0; i < oMenuToggles.length; i += 1) {
            if (oMenuToggles[i].classList.contains('menu-toggle--active')) {
                oMenuToggles[i].classList.remove('menu-toggle--active');
            } else {
                oMenuToggles[i].classList.add('menu-toggle--active');
            }
        }
    };

    const openMainNavSubmenu = (e) => {
        const oMenuItem = e.target;

        if (oMenuItem.classList.contains('js-submenu')) {
            const oSubMenu = oMenuItem.querySelector('.navigation__submenu');

            clearTimeout(fHoverOutTimeout);

            const tl = new TimelineLite();
            tl.timeScale(3);

            fHoverInTimeout = setTimeout(() => {
                oMenuItem.children[0].classList.add('hover-active');
                oSubMenu.classList.add('open');
                website.body.classList.add('faded');
            }, 100);
        } else {
            const oOpenSubMenu = document.querySelector('.navigation__submenu.open');
            if (oOpenSubMenu !== null) {
                oOpenSubMenu.parentNode.children[0].classList.remove('hover-active');
                oOpenSubMenu.classList.remove('open');
                website.body.classList.remove('faded');
            }
        }
    };

    const closeMainNavSubmenu = (e) => {
        // let oMenuItem = e.target;
        const oMenuItem = document.querySelector('.navigation__submenu.open');
        let oMenuItemParent;

        clearTimeout(fHoverInTimeout);

        if (oMenuItem) {
            oMenuItemParent = oMenuItem.parentNode;
        }

        if (oMenuItemParent && oMenuItemParent.classList.contains('js-submenu')) {
            const oSubMenu = oMenuItemParent.querySelector('.navigation__submenu');

            fHoverOutTimeout = setTimeout(() => {
                oMenuItemParent.children[0].classList.remove('hover-active');
                oSubMenu.classList.remove('open');
                website.body.classList.remove('faded');
            }, 500);
        }
    };

    const toggleMobileNav = () => {
        if (bMobileMenuActive && oMobileMenuSubItems) {
            oMobileMenu.classList.remove('active');
            website.body.classList.remove('no-scroll');

            // Remove active class on any active submenus as well
            for (let i = 0; i < oMobileMenuSubItems.length; i += 1) {
                const oSubMenu = oMobileMenuSubItems[i].querySelector('.mobile-navigation__sub');
                if (oSubMenu && oSubMenu.getAttribute('style') !== null) {
                    oSubMenu.removeAttribute('style');
                }
                if (oSubMenu && oSubMenu.classList.contains('active')) {
                    oSubMenu.classList.remove('active');
                    oMobileMenu.classList.remove('submenu--active');
                    oMenuToggles[0].classList.remove('submenu--active');
                }
            }
        } else {
            if (app.searchOpen) {
                app.toggleSearch();
            }

            oMobileMenu.classList.add('active');
            website.body.classList.add('no-scroll');
        }

        bMobileMenuActive = !bMobileMenuActive;
        toggleBtnClasses();
    };

    const toggleSubMenuClasses = (submenu, isLastSubmenu, activeSubmenus) => {
        if (submenu.classList.contains('active')) {
            submenu.classList.remove('active');

            for (let i = 0; i < activeSubmenus.length; i += 1) {
                activeSubmenus[i].setAttribute('style', 'transform: translateX(-100%)');
                activeSubmenus[i].scrollTop = 0;
            }

            if (isLastSubmenu) {
                oMobileMenu.classList.remove('submenu--active');
                oMenuToggles[0].classList.remove('submenu--active');
                oMobileMenuSubBackLink.classList.remove('active');
            } else {
                activeSubmenus[0].setAttribute('style', '');
                //activeSubmenus[0].setAttribute('style', 'overflow-y: scroll;');
                activeSubmenus[0].scrollTop = 0;
            }
        } else {
            submenu.classList.add('active');


            for (let i = 0; i < activeSubmenus.length; i += 1) {
                activeSubmenus[i].setAttribute('style', 'transform: translateX(-100%);');
                activeSubmenus[i].scrollTop = 0;
            }
            if (activeSubmenus.length) {
                //submenu.setAttribute('style', 'overflow-y: scroll; transform: translateX(100%);');
                submenu.setAttribute('style', 'transform: translateX(100%);');
                submenu.scrollTop = 0;
            } else {
                submenu.setAttribute('style', '');
                //submenu.setAttribute('style', 'overflow-y: scroll;');
                submenu.scrollTop = 0;

            }


            oMobileMenu.classList.add('submenu--active');
            oMenuToggles[0].classList.add('submenu--active');
            oMobileMenuSubBackLink.classList.add('active');
        }
    };

    const toggleMobileSubMenu = (submenus, activeSubmenus) => {
        if (submenus.length) {
            // Only toggle the last opened Submenu
            const submenu = submenus[submenus.length - 1];
            const lastSubMenu = submenus.length <= 1;

            toggleSubMenuClasses(submenu, lastSubMenu, activeSubmenus);
        } else {
            const submenu = submenus;
            toggleSubMenuClasses(submenu, true, activeSubmenus);
        }
    };

    const toggleSideNav = () => {
        if (bSideNavigationActive) {
            oSideNavigation.classList.remove('active');
            website.body.classList.remove('no-scroll');
            toggleBtnClasses();

            oSideNavigationBackdrop.removeEventListener('click', toggleSideNav);
            removeBackdrop(oSideNavigationBackdrop);
        } else {
            oSideNavigation.classList.add('active');
            website.body.classList.add('no-scroll');
            toggleBtnClasses();

            oSideNavigationBackdrop = createBackdrop();
            oSideNavigationBackdrop.addEventListener('click', toggleSideNav);
        }

        bSideNavigationActive = !bSideNavigationActive;
    };

    const checkMenuToShow = () => {
        // If Mobile Menu is already active and
        // user scales browser back to desktop
        // to make sure close button still works
        if (bMobileMenuActive) {
            toggleMobileNav();
            return false;
        }

        // If Sidebar is already active and
        // user scales browser back to mobile
        // to make sure close button still works
        if (bSideNavigationActive) {
            toggleSideNav();
            return false;
        }

        if (website.iScreenWidth < website.mobileBreakpoint) {
            toggleMobileNav();
        } else {
            toggleSideNav();
        }

        return true;
    };


    const addMainMenuItemsListeners = (i) => {
        oMainMenuItems[i].addEventListener('mouseenter', (e) => {
            openMainNavSubmenu(e);
        });
    };

    for (let i = 0; i < oMenuToggles.length; i += 1) {
        oMenuToggles[i].addEventListener('click', () => {
            checkMenuToShow();
        });
    }

    if (oMobileMenuSubItems) {

        for (let i = 0; i < oMobileMenuSubItems.length; i += 1) {
            const oSubMenu = oMobileMenuSubItems[i].querySelector('.mobile-navigation__sub');

            const oLink =
                oMobileMenuSubItems[i].querySelector('.sidebar-navigation__list__link, .mobile-navigation__sub__link');

            if (oSubMenu != null) {
                oLink.addEventListener('click',
                    (e) => {
                        const oAllActiveSubmenuItems = document.querySelectorAll('.mobile-navigation__sub.active');
                        toggleMobileSubMenu(oSubMenu, oAllActiveSubmenuItems);
                        e.stopPropagation();
                        e.preventDefault();
                    });
            }
        }
    }

    if (oMobileMenuSubBackLink) {
        oMobileMenuSubBackLink.addEventListener('click', () => {
            const oSubMenus = document.querySelectorAll('.mobile-navigation__sub.active');
            toggleMobileSubMenu(oSubMenus, oSubMenus);
        });
    }

    if (oMainNavigation) {

        oMainNavigation.addEventListener('mouseleave',
            (e) => {
                closeMainNavSubmenu(e);
            });
    }

    for (let i = 0; i < oMainMenuItems.length; i += 1) {
        addMainMenuItemsListeners(i);
    }
}
